module.exports = __webpack_public_path__ + "img/6_156.98c15e94.png";